export enum RoleId {
  SystemAdministrator = 'SYSTEM_ADMINISTRATOR',
  Administrator = 'ADMINISTRATOR',
  ProjectManager = 'PROJECT_MANAGER',
  ResourceScheduler = 'RESOURCE_SCHEDULER',
  Supervisor = 'SUPERVISOR',
  Foreman = 'FOREMAN',
  GeneralCrew = 'GENERAL_CREW',
}